export default __webpack_public_path__ + "static/membershipHero@2x-a67de6252dd99315409a058898bca09b.jpg";